import React from 'react'
import { Link } from 'react-router-dom'
import { formatUpdatedAt, formatVolumeLabel } from './roleSystemToc'

export default function RoleSystemDetailHero({ title, summary, sortOrder, updatedAt }) {
  const revised = formatUpdatedAt(updatedAt)

  return (
    <header className="role-system-detail-hero">
      <Link to="/sistemas-de-rol" className="role-system-detail-hero__back">
        <span aria-hidden="true">←</span> Volver al códice
      </Link>

      <div className="role-system-detail-hero__head">
        <span className="role-system-detail-hero__eyebrow">
          制 · {formatVolumeLabel(sortOrder, 0)}
        </span>
        <h1 className="role-system-detail-hero__title">{title}</h1>
        {summary ? <p className="role-system-detail-hero__summary">{summary}</p> : null}
        {revised ? (
          <p className="role-system-detail-hero__meta">Última revisión · {revised}</p>
        ) : null}
      </div>

      <div className="role-system-detail-hero__bottom-line" aria-hidden="true" />
    </header>
  )
}
